/**
 * Smooth scroll from blog table-of-contents to heading anchors.
 * Offset is CSS `scroll-margin` on `.block-contents__anchor-link`.
 *
 * @param {ParentNode} [root=document]
 */
export function initBlockContents(root = document) {
  const blocks = root.querySelectorAll('.block-contents');

  blocks.forEach((block) => {
    if (!(block instanceof HTMLElement) || block.dataset.blockContentsInited === '1') {
      return;
    }
    block.dataset.blockContentsInited = '1';

    block.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }

      const link = target.closest('a[href^="#"]');
      if (!(link instanceof HTMLAnchorElement) || !block.contains(link)) {
        return;
      }

      const id = decodeURIComponent(link.hash.slice(1));
      if (!id) {
        return;
      }

      const dest = document.getElementById(id);
      if (!dest) {
        return;
      }

      event.preventDefault();

      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      dest.scrollIntoView({
        behavior: prefersReduced ? 'auto' : 'smooth',
        block: 'start',
      });

      if (location.hash !== `#${id}`) {
        history.pushState(null, '', `#${id}`);
      }
    });
  });
}
